import {ViewBreakpoints} from '@pedal/pdl-shared-libraries/constants/view-breakpoints';

const bulletStyles = [
  `.swiper-pagination-bullet {
    opacity: 1;
    background: #A3A3A3;
    width: 16px;
    height: 16px;
  }
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    background: #464646;
  }
`,
];

const carouselConfigs = {
  slideshow: {
    autoplay: {delay: 7000},
    effect: 'fade',
    injectStyles: bulletStyles,
    pagination: {clickable: true},
  },
  centered: {
    spaceBetween: 20,
    scrollbar: {hide: true, snapOnRelease: true},
    slidesPerGroup: 1,
    centeredSlides: true,
    centeredSlidesBounds: true,
    injectStyles: [
      `.swiper {
        padding: 0;
      }
      .swiper-button-disabled {
        background: var(--gray-10);
        background-color: var(--gray-10);
      }`,
    ],
    breakpoints: {
      [ViewBreakpoints.small]: {
        slidesPerView: 1,
      },
      [ViewBreakpoints.medium]: {
        slidesPerView: 2.25,
      },
      [ViewBreakpoints.large]: {
        slidesPerView: 2.75,
      },
      [ViewBreakpoints.xlarge]: {
        slidesPerView: 2.75,
      },
      [ViewBreakpoints.xxlarge]: {
        slidesPerView: 2.75,
      },
    },
  },
  ltr: {
    spaceBetween: 20,
    scrollbar: {hide: true, snapOnRelease: true},
    breakpoints: {
      [ViewBreakpoints.small]: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
      [ViewBreakpoints.medium]: {
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
      [ViewBreakpoints.large]: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      [ViewBreakpoints.xlarge]: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      [ViewBreakpoints.xxlarge]: {
        slidesPerView: 5,
        slidesPerGroup: 5,
      },
    },
  },
};

export {carouselConfigs, bulletStyles};
